import { MaterialType } from "@enums/materialType.enum";
import { Model } from "@interfaces/model.interface";

export interface ProductionToolProgram extends Model {
	blockSize?: string;
	blockToolOrderIds?: number[];
	datum?: string;
	holeDiameter?: string;
	imageUrl?: string;
	isActive: boolean;
	isToolComplete: boolean;
	machineId: number;
	materialType?: MaterialType;
	notes?: string;
	operationId?: number;
	partId: number;
	positionX?: number;
	positionY?: number;
	positionZ?: number;
	productionToolId: number;
	programName: string;
	programmerSignedAt?: Date;
	programmerUserProfileId?: number;
	secondProgrammerSignedAt?: Date;
	secondProgrammerUserProfileId?: number;
	toolFixtureRef?: string;
	viceSetUp: boolean;
	viceStickout?: string;
	weldedBarSize?: string;
}

export class ProductionToolProgram implements ProductionToolProgram {
	isActive = true;
	isToolComplete = false;
	machineId = 0;
	partId = 0;
	productionToolId = 0;
	programName = "";
	viceSetUp = false;

	constructor(data?: Partial<ProductionToolProgram>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
